import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PaymentForm from './PaymentForm';
import { IPlan } from '@wot/typings';
import useCurrency from '../../../hooks/useCurrency';

const Checkout = () => {
  const convertAmount = useCurrency();
  const [plan, setPlan] = useState<IPlan>();
  const [grandTotal, setGrandTotal] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      // @ts-ignore
      setPlan(location.state.plan);
    }
  }, []);

  if (!plan?._id) {
    return <div className="text-white">Page not Found</div>;
  }

  return (
    <div className="w-full h-full min-h-screen z-50 pt-20">
      <div className="w-[90%] lg:w-3/4 h-full mx-auto my-auto flex flex-col md:flex-row gap-7 p-5 py-10 bg-white border border-primary rounded-2xl drop-shadow-[0_15px_30px_rgba(125,155,192,0.25)]">
        <div className="w-full md:w-1/2 flex flex-col gap-4">
          <h1 className="text-xl font-semibold">Checkout</h1>
          <div className="w-full py-4 border-t flex flex-col gap-4">
            <div className="w-full flex justify-between gap-2">
              <p className="text-sm font-semibold">Price</p>
              <p className="text-sm font-bold">
                {convertAmount(plan.costPerSession * plan.purchasedSessions).amountString}
              </p>
            </div>
            <div className="w-full flex justify-between gap-2">
              <p className="text-sm font-semibold">Discount</p>
              <p className="text-sm font-bold text-green-500">-{plan.discount}%</p>
            </div>
            {/* <div className="w-full flex justify-between gap-2">
              <p className="text-sm font-semibold">GST(18%)</p>
              <p className="text-sm font-bold">864</p>
            </div> */}
            <div className="w-full">
              <div className="w-full flex justify-between gap-2">
                <p className="text-sm font-bold">Total amount to pay</p>
                <p className="text-sm font-bold text-green-500">{convertAmount(plan.totalCost).amountString} </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 mt-6 md:mt-0 flex items-center justify-center">
          <PaymentForm plan={plan} grandTotal={plan?.totalCost} />
        </div>
      </div>
    </div>
  );
};

export default Checkout;
